module.exports = __webpack_public_path__ + "img/9788946054851.920f4781.jpg";